import { render, staticRenderFns } from "./StageSummaryAlt.vue?vue&type=template&id=148f78b2"
import script from "./StageSummaryAlt.vue?vue&type=script&lang=js"
export * from "./StageSummaryAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports